import Marquee from "react-fast-marquee";

const WORDS = [
  "Meta Ads",
  "Ad Strategy",
  "Automation",
  "CAQ",
  "Full-Funnel",
  "Retention",
  "Nurturing",
  "Scaling",
];

const Row = ({ direction, speed }) => (
  <Marquee direction={direction} speed={speed} gradient={false} autoFill>
    {WORDS.map((w, i) => (
      <div key={i} className="flex items-center">
        <span className="font-display px-6 text-5xl uppercase text-black sm:px-10 sm:text-7xl">
          {w}
        </span>
        <span className="text-3xl text-black sm:text-5xl">✦</span>
      </div>
    ))}
  </Marquee>
);

export const KineticMarquee = () => {
  return (
    <section
      data-testid="marquee-section"
      className="relative overflow-hidden border-y-4 border-black bg-yellow-400 py-8"
    >
      <div className="-rotate-2">
        <Row direction="left" speed={55} />
        <div className="my-2 h-[3px] w-full bg-black/80" />
        <Row direction="right" speed={40} />
      </div>
    </section>
  );
};
